import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Layout from '../../components/layout/Layout';
import SubjectSelect from './SubjectSelect';
import QuestionView from './QuestionView';
import MockExam from './MockExam';
import WrongNote from './WrongNote';
import './Exam.css';

type ExamScreen = 'subject' | 'question' | 'mock' | 'wrong';

const ExamPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const initialSubject = searchParams.get('subject') || '';

  const [screen, setScreen] = useState<ExamScreen>('subject');
  const [examType, setExamType] = useState<'필기' | '실기'>('필기');
  const [selectedSubject, setSelectedSubject] = useState<any>(null);

  const handleSelect = (subject: any, type: '필기' | '실기', selectedMode: 'normal' | 'mock' | 'wrong') => {
    const sc = selectedMode === 'mock' ? 'mock' : selectedMode === 'wrong' ? 'wrong' : 'question';
    setSelectedSubject(subject);
    setExamType(type);
    setScreen(sc);
  };

  const handleModeChange = (mode: 'normal' | 'mock' | 'wrong') => {
    const sc = mode === 'mock' ? 'mock' : mode === 'wrong' ? 'wrong' : 'question';
    setScreen(sc);
  };

  const goBack = () => {
    setScreen('subject');
  };

  return (
    <Layout>
      <div className="exam-page">
        {screen === 'subject' && (
          <SubjectSelect onSelect={handleSelect} initialSubjectName={initialSubject} />
        )}
        {screen === 'question' && selectedSubject && (
          <QuestionView
            subject={selectedSubject}
            examType={examType}
            onBack={goBack}
            onModeChange={handleModeChange}
          />
        )}
        {screen === 'mock' && selectedSubject && (
          <MockExam
            subject={selectedSubject}
            examType={examType}
            onBack={goBack}
            onModeChange={handleModeChange}
          />
        )}
        {screen === 'wrong' && (
          <WrongNote examType={examType} onBack={goBack} onModeChange={handleModeChange} />
        )}
      </div>
    </Layout>
  );
};

export default ExamPage;
